import ValidSignSignatureCounter from './ValidSignSignatureCounter';

export default ValidSignSignatureCounter;
